module.exports = __webpack_public_path__ + "img/william-henry-johnson.1cf62c38.png";